import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import { auth } from '../../helpers/Firebase';
import axios from 'axios';

import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../actions';

import {
  loginUserSuccess,
  logoutUserSuccess,
  loginUserError,
  registerUserSuccess,
  registerUserError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
} from './actions';

import { adminRoot, currentUser, apiUrl } from "../../constants/defaultValues"
import { setCurrentUser } from '../../helpers/Utils';

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const loginWithEmailPasswordAsync = async (username, password, cloudId) => {
  const payload = {
    cloud_id: cloudId,
    user: username,
    password: password
  };

  try {
    const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, payload)

    return resp.data
  } catch (err) {
    return err;
  }
}

function* loginWithEmailPassword({ payload }) {
  const { username, password, cloudId } = payload.user;
  const { history } = payload;
  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, username, password, cloudId);
    console.log("loginUser", loginUser);

    if (loginUser.Token) {
      // Set localStorage values
      localStorage.setItem('userName', username);
      localStorage.setItem('cloud_id', cloudId);
      localStorage.setItem('user_id', loginUser.id);
      localStorage.setItem('companyName', loginUser.company);
      localStorage.setItem('sub_cloud_id', loginUser.sub_cloud_id || '');
      localStorage.setItem('Token', loginUser.Token);
      localStorage.setItem('subscriber_id', loginUser.subscriber_id);
      localStorage.setItem('type', loginUser.type);

      // Create user object with all necessary data including type
      const item = { 
        userObject: loginUser,
        type: loginUser.type, // Explicitly include type in Redux state
        ...currentUser 
      };

      setCurrentUser(item);
      yield put(loginUserSuccess(item));
      history.push(adminRoot);
    } else {
      yield put(loginUserError('Login failed'));
    }
  } catch (error) {
    yield put(loginUserError(error.message || 'Login failed'));
  }
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

const registerWithEmailPasswordAsync = async (email, password) => {
  // await auth
  //   .createUserWithEmailAndPassword(email, password)
  //   .then((user) => user)
  //   .catch((error) => error);
}


function* registerWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const registerUser = yield call(
      registerWithEmailPasswordAsync,
      email,
      password
    );
    if (!registerUser.message) {
      const item = { uid: registerUser.user.uid, ...currentUser };
      setCurrentUser(item);
      yield put(registerUserSuccess(item));
      history.push(adminRoot);
    } else {
      yield put(registerUserError(registerUser.message));
    }
  } catch (error) {
    yield put(registerUserError(error));
  }
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  // Clear all localStorage items
  localStorage.clear();
  // Redirect to login page
  history.push('/user/login');
};

function* logout({ payload }) {
  const { history } = payload;
  setCurrentUser(null);
  yield call(logoutAsync, history);
  yield put(logoutUserSuccess(history));
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (email) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/forgotPassword`, {
      email: email
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

const isPasswordApiSuccess = (response) => {
  if (!response || response.response) {
    return false;
  }
  if (response.success === true || response.result === 'Success') {
    return true;
  }
  return typeof response.message === 'string' && /success/i.test(response.message);
};

function* forgotPassword({ payload }) {
  const { email } = payload.forgotUserMail;
  try {
    const forgotPasswordStatus = yield call(forgotPasswordAsync, email);

    if (isPasswordApiSuccess(forgotPasswordStatus)) {
      yield put(forgotPasswordSuccess('success'));
    } else if (forgotPasswordStatus.response && forgotPasswordStatus.response.data) {
      // Handle API error response
      yield put(forgotPasswordError(forgotPasswordStatus.response.data.message || 'Password reset failed'));
    } else if (forgotPasswordStatus.message) {
      // Handle general error
      yield put(forgotPasswordError(forgotPasswordStatus.message));
    } else {
      yield put(forgotPasswordError('Password reset failed. Please try again.'));
    }
  } catch (error) {
    yield put(forgotPasswordError(error.message || 'Password reset failed'));
  }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/resetPassword`, {
      token: resetPasswordCode,
      new_password: newPassword
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

function* resetPassword({ payload }) {
  const { newPassword, resetPasswordCode, history } = payload;
  try {
    const resetPasswordStatus = yield call(
      resetPasswordAsync,
      resetPasswordCode,
      newPassword
    );

    if (isPasswordApiSuccess(resetPasswordStatus)) {
      yield put(resetPasswordSuccess('success'));
      // Redirect to login page after successful password reset
      if (history) {
        history.push('/user/login');
      }
    } else if (resetPasswordStatus.response && resetPasswordStatus.response.data) {
      // Handle API error response
      yield put(resetPasswordError(resetPasswordStatus.response.data.message || 'Password reset failed'));
    } else if (resetPasswordStatus.message) {
      // Handle general error
      yield put(resetPasswordError(resetPasswordStatus.message));
    } else {
      yield put(resetPasswordError('Password reset failed. Please try again.'));
    }
  } catch (error) {
    yield put(resetPasswordError(error.message || 'Password reset failed'));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchForgotPassword),
    fork(watchResetPassword),
  ]);
}
